import React from "react";

function PointerIcon() {
  return (
    <svg
      width="19"
      height="21"
      viewBox="0 0 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.75027 12.25L3.61627 10.421C3.2862 10.1407 2.8635 9.99359 2.43075 10.0083C1.99799 10.0231 1.58628 10.1987 1.27607 10.5007C0.965852 10.8028 0.779418 11.2097 0.753196 11.6419C0.726973 12.0742 0.862846 12.5006 1.13427 12.838L4.49327 16.972C5.53027 18.249 6.04926 18.887 6.74527 19.265C6.86993 19.3328 6.99811 19.3939 7.12926 19.448C7.86226 19.75 8.68526 19.75 10.3293 19.75H11.3793C12.6173 19.75 13.2353 19.75 13.7773 19.594C14.6691 19.3375 15.444 18.779 15.9693 18.014C16.287 17.5509 16.4817 16.9677 16.8705 15.8032L16.8753 15.789C17.4913 13.939 17.7453 13.25 17.7453 12.224C17.7453 10.75 16.9323 9.741 15.8103 9.068C15.1313 8.662 14.1673 8.517 12.2383 8.228L9.25027 7.75V2.5C9.25027 2.03587 9.06589 1.59075 8.7377 1.26256C8.40951 0.934375 7.96439 0.75 7.50027 0.75C7.03614 0.75 6.59102 0.934375 6.26283 1.26256C5.93464 1.59075 5.75027 2.03587 5.75027 2.5V12.25Z"
        stroke="#F5C30B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default PointerIcon;
